import React, { useState, useRef, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import enFlag from './assets/1f1ec-1f1e7.svg';
import itFlag from './assets/1f1ee-1f1f9.svg';

function CustomNavbar({ navbarItems }) {
    const { i18n } = useTranslation();
    const [expanded, setExpanded] = useState(false);
    const navbarRef = useRef(null);

    const handleChangeLanguage = (lang) => {
        return () => {
            i18n.changeLanguage(lang);
            localStorage.setItem('i18nextLng', lang); // Salva la lingua in localStorage
            setExpanded(false); // Chiudi la navbar
        };
    };

    const handleNavClick = () => {
        setExpanded(false); // Chiudi la navbar quando si preme su un link
    };

    const handleClickOutside = (event) => {
        if (navbarRef.current && !navbarRef.current.contains(event.target)) {
            setExpanded(false); // Chiudi la navbar se si clicca fuori
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <>
            <div className='bg-accent'>
                <div className='container text-light text-end py-2'><a href='mailto:cateverinavivarelli@gmai.com' className='text-light'>caterinavivarelli@gmail.com</a></div>
            </div>
            <Navbar ref={navbarRef} sticky='top' expand="lg" className="bg-light py-3" expanded={expanded}>
                <Container>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={() => setExpanded(expanded ? false : true)} />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="me-auto">
                            {navbarItems.map((item, index) => (
                                <span className='container d-flex justify-content-start align-items-center ps-lg-3 py-3 py-lg-0' key={index}>
                                    <FontAwesomeIcon icon={item.icon}></FontAwesomeIcon>
                                    <Nav.Link className='textc-black ps-2 no-string-break' href={item.url} onClick={handleNavClick}>{item.label}</Nav.Link>
                                </span>
                            ))}
                        </Nav>
                            <Nav.Item className='ms-auto'>
                                <button className="bg-transparent textc-black border-0 me-2 ps-lg-4" onClick={handleChangeLanguage("it")}>
                                    <img src={itFlag} alt="Italiano" style={{ width: '24px', height: '24px' }} />
                                </button>
                                <button className="bg-transparent textc-black border-0" onClick={handleChangeLanguage("en")}>
                                    <img src={enFlag} alt="English" style={{ width: '24px', height: '24px' }} />
                                </button>
                            </Nav.Item>    
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </>
    );
}

export default CustomNavbar;
